import React, { useState, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Modal } from "antd";
import { pathOr } from "ramda";
import { broadCastPreviewListAction } from "../../../../../sagas/saga-broadcast";
import CustomButton from "../../../../../components/customButton";
import { getSortedStringValues } from "../../../../../helper/helpers";
import DataTable from "../../dataTable";
import BroadcastService from "../../../../../service/BroadcastUserService";
import { setPopup } from "../../../../../actions/popupAction";
import useWindowDimensions from "../../../../../components/custom-hooks/useWindowDimensions";
import { MOBILE_WIDTH } from "../../../../../constants/constants";
import MobileHeader from "../../../../../components/header/mobileHeader";
import "./styles.scss";

const PreviewFile = (props) => {
  const {
    handlePreview,
    fileForPreview,
    handleUseCustomFile,
    userType,
    refreshData,
    editDeleteAccess,
  } = props;
  const [state, setState] = useState({
    columns: [],
    refresh: false,
    isLoading: false,
    editModeStatus: false,
  });

  const { width } = useWindowDimensions();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const broadcast = new BroadcastService();
  const dispatch = useDispatch();
  const actionRef = useRef(false);

  const formatHeaders = (headers) => {
    const getHeader = (header) => {
      if (header === "CellPhone") {
        return "CellPhone";
      } else if (header === "LandlineNo") {
        return "Column_2";
      } else {
        return header;
      }
    };
    return headers.map((header) => ({
      title: getHeader(header.Header),
      dataIndex: header.accessor,
      key: header.accessor,
      ellipsis: true,
      sorter: (a, b) =>
        getSortedStringValues(a[header.accessor], b[header.accessor]),
      width: "20rem",
    }));
  };

  const fetchTableData = (filters) => {
    return new Promise((resolve, reject) => {
      const { order: sortBy, search, ...others } = filters;
      const filter = search ? encodeURIComponent(JSON.stringify(search)) : "";
      const { fileNickName } = fileForPreview || null;
      props.broadCastPreviewList(
        { ...others, filter, sortBy, fileNickName, userType },
        (status, response) => {
          const { data, count } = response || {};
          if (status && data && data.length) {
            const headers = JSON.parse(data[0].headers);
            const columns = formatHeaders(headers);
            const fields = data.map((item) => ({
              id: item.id,
              ...JSON.parse(item.fields),
            }));
            setState((st) => ({
              ...st,
              columns,
            }));
            resolve({ rows: fields, count });
          }
          resolve({ rows: [], count: 0 });
        }
      );
    });
  };

  const handleSelect = async () => {
    handlePreview({});
    handleUseCustomFile(fileForPreview);
  };

  const handleDiscard = async () => {
    if (actionRef && actionRef.current) return;
    else {
      try {
        actionRef.current = true;
        const { fileNickName } = fileForPreview || null;
        const obj = {
          removeIdArray: selectedRowKeys,
          fileNickName,
        };
        setState((st) => ({ ...st, isLoading: true }));
        const response = await broadcast.deleteRecords(userType, obj);
        if (response?.data?.allDeleted) {
          handlePreview({});
          refreshData();
          setState((st) => ({ ...st, isLoading: false }));
        } else {
          setState((st) => ({ ...st, refresh: true, isLoading: false }));
        }
        clearSelection();
        dispatch(
          setPopup({
            customPopupMessage: true,
            messageType: "success",
            message: response.data.message,
          })
        );
        actionRef.current = false;
      } catch (err) {
        setState((st) => ({ ...st, isLoading: false }));
        dispatch(
          setPopup({
            customPopupMessage: true,
            messageType: "error",
            message: pathOr(
              "Something went wrong",
              ["response", "data", "message"],
              err
            ),
          })
        );
        actionRef.current = false;
      }
    }
  };

  const getSuggestions = async (column, value) => {
    const data = await broadcast.getSuggestionsPreview(
      fileForPreview.fileId,
      column,
      value
    );
    return data || [];
  };

  const firstCol = [
    {
      dataIndex: "PhoneNo",
      key: "PhoneNo",
    },
  ];
  const clearSelection = () => {
    setSelectedRowKeys([]);
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setState((st) => ({
      ...st,
      refresh: false,
    }));
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    hideSelectAll: false,
    preserveSelectedRowKeys: true,
    getCheckboxProps: (record) => ({
      className: "checkbox-red",
    }),
  };

  const onEditClick = () => {
    setState((st) => ({
      ...st,
      editModeStatus: true,
    }));
  };

  const isSelected = selectedRowKeys.length > 0;
  return (
    <>
      {width > MOBILE_WIDTH && (
        <Modal
          className="preview-modal"
          mask={false}
          visible={props.isVisible}
          width={1000}
          footer={[
            <CustomButton
              className={`mr-8 cancel-button ${isSelected && "danger-button"}`}
              onClick={() => {
                handlePreview({});
              }}
              title={"Back"}
            />,
            <CustomButton
              className={isSelected && "danger-button"}
              htmlType="submit"
              type="primary"
              title={isSelected ? "Discard" : "Select"}
              onClick={() => {
                isSelected ? handleDiscard() : handleSelect();
              }}
            />,
          ]}
        >
          <DataTable
            rowSelection={
              editDeleteAccess !== 0 && {
                type: "checkbox",
                ...rowSelection,
              }
            }
            columns={state.columns.length > 0 ? state.columns : firstCol}
            fileName={fileForPreview.fileNickName}
            getSuggestions={getSuggestions}
            fetchTableData={fetchTableData}
            selected={selectedRowKeys.length}
            clearSelection={clearSelection}
            refresh={state.refresh}
            loading={false}
          />
        </Modal>
      )}
      <div className="mobile-preview">
        <div className="header-bar-mob">
          <MobileHeader
            showLogo={false}
            showNotifications={false}
            showHelp={false}
            showAccountDetails={false}
            backgroundColor={state.editModeStatus ? "blue-bg" : "gray-bg"}
            showBackButton={state.editModeStatus ? false : true}
            showPageTitle={true}
            pageTitle={fileForPreview.fileNickName}
            handleBackButton={handlePreview}
            showEditIcon={
              state.editModeStatus
                ? false
                : editDeleteAccess === 0
                  ? false
                  : true
            }
            handleEditIcon={onEditClick}
            showCloseIcon={state.editModeStatus ? true : false}
            showDeleteIcon={
              state.editModeStatus && selectedRowKeys.length ? true : false
            }
            handleDelete={handleDiscard}
          />
        </div>
        {width < MOBILE_WIDTH && (
          <div className="preview-container">
            <DataTable
              rowSelection={
                editDeleteAccess !== 0 &&
                state.editModeStatus && {
                  type: "checkbox",
                  ...rowSelection,
                }
              }
              columns={state.columns.length > 0 ? state.columns : firstCol}
              fileName={fileForPreview.fileNickName}
              getSuggestions={getSuggestions}
              fetchTableData={fetchTableData}
              selected={selectedRowKeys.length}
              clearSelection={clearSelection}
              refresh={state.refresh}
              loading={state.isLoading}
            />
          </div>
        )}
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  broadCastPreviewList: bindActionCreators(
    broadCastPreviewListAction,
    dispatch
  ),
});

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(PreviewFile)
);
